const OCTA_READY_RETRY_MS = 100
const OCTA_READY_MAX_ATTEMPTS = 50
const OCTA_READY_EVENT = 'on0ctaChatReady'
const DEMIA_SCRIPT_ID = 'demia-widget-script'
const DEMIA_WIDGET_ID = 'demia-widget'
const DEMIA_WELCOME_MESSAGE_ID = 'demia-welcome-message'
const DEMIA_STYLE_SELECTOR = 'style[data-demia-widget]'

function getOctaChat() {
  return (window.frames && window.frames.octadesk && window.frames.octadesk.chat) || null
}

function getOctaChatWithLogin() {
  const chat = getOctaChat()
  return chat && typeof chat.login === 'function' ? chat : null
}

function whenOctaReady(action, attempts = 0, resolve = getOctaChat) {
  const chat = resolve()
  if (chat) {
    action(chat)
    return
  }
  if (attempts >= OCTA_READY_MAX_ATTEMPTS) return
  setTimeout(
    () => whenOctaReady(action, attempts + 1, resolve),
    OCTA_READY_RETRY_MS
  )
}

export const octaChat = {
  hide() {
    whenOctaReady(chat => chat.hide())
  },
  show() {
    whenOctaReady(chat => {
      chat.showButton()
      chat.show()
    })
  },
  toggle() {
    whenOctaReady(chat => chat.toggle())
  },
  login({ name, email, customFields } = {}) {
    if (!name || !email) return

    const payload = { name, email }
    if (customFields && customFields.length) payload.customFields = customFields

    let applied = false
    function apply(chat) {
      if (applied) return
      applied = true
      chat.login(payload)
    }

    window.addEventListener(
      OCTA_READY_EVENT,
      () => whenOctaReady(apply, 0, getOctaChatWithLogin),
      { once: true }
    )
    whenOctaReady(apply, 0, getOctaChatWithLogin)
  }
}

function getDemiaScript() {
  return document.getElementById(DEMIA_SCRIPT_ID)
}

function getDemiaWidget() {
  return document.getElementById(DEMIA_WIDGET_ID)
}

function teardownDemia() {
  window.demiaWidget?.cleanup?.()
  getDemiaScript()?.remove()
  getDemiaWidget()?.remove()
  document.getElementById(DEMIA_WELCOME_MESSAGE_ID)?.remove()
  document
    .querySelectorAll(DEMIA_STYLE_SELECTOR)
    .forEach((style) => style.remove())
}

export const demia = {
  setUser({ nome, email, empresa } = {}) {
    window.chatbotUser = { nome, email, empresa }
  },
  load(embedUrl) {
    const injected = getDemiaScript()
    if (injected?.getAttribute('src') === embedUrl) {
      this.restart()
      return
    }
    if (injected) teardownDemia()

    const script = document.createElement('script')
    script.id = DEMIA_SCRIPT_ID
    script.src = embedUrl
    script.defer = true
    document.body.appendChild(script)
  },
  restart() {
    const widget = getDemiaWidget()
    if(!widget) return

    widget.style.display = ''

  },
  cleanup() {
    const widget = getDemiaWidget()
    if(!widget) return

    widget.style.display = 'none'
  }
}
